export const PRODUCT_CATEGORIES = [
  "vegetables",
  "fruits",
  "grains",
  "livestock",
] as const;

export type ProductCategory = (typeof PRODUCT_CATEGORIES)[number];

export const ORDER_STATUSES = [
  "pending",
  "accepted",
  "fulfilled",
  "cancelled",
] as const;

export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const PAYMENT_METHODS = ["cash_on_delivery", "mpesa"] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash_on_delivery: "Cash on delivery",
  mpesa: "M-Pesa",
};

export function formatPaymentMethodLabel(method: PaymentMethod) {
  return PAYMENT_METHOD_LABELS[method];
}

export const PRODUCT_UNITS = [
  "piece",
  "kg",
  "g",
  "litre",
  "ml",
  "sack_90kg",
  "crate",
  "bunch",
] as const;

export type ProductUnit = (typeof PRODUCT_UNITS)[number];

export const PRODUCT_UNIT_LABELS: Record<ProductUnit, string> = {
  piece: "Piece",
  kg: "Kilogram (kg)",
  g: "Gram (g)",
  litre: "Litre",
  ml: "Millilitre",
  sack_90kg: "Sack of 90 kg",
  crate: "Crate",
  bunch: "Bunch",
};

export function formatProductUnitLabel(unit: ProductUnit) {
  return PRODUCT_UNIT_LABELS[unit];
}
